export function readAPIErrorMessage(xhr) {
  var errors = "Unknow Error";
  if (xhr.responseJSON) {
    if (xhr.responseJSON.message) {
      errors = xhr.responseJSON.message;
    } else if (xhr.responseJSON.errors) {
      errors = xhr.responseJSON.errors;
      if (Array.isArray(errors)) {
        if (errors[0].exception) {
          errors = errors[0].exception;
        } else {
          errors = errors[0];
        }
      }
    }
  }
  return errors;
}



// WEBPACK FOOTER //
// ./src/helper/api_helper.jsx